const m10Section = {
  id: 'm10',
  name: '2022ScoresheetM10Sub1Label',
  fields: [
    {
      scoring: '2022ScoresheetM10Sub2Label',
      id: 'm10_scoring_1',
      options: [
        {
          description: 'noLabel',
          value: false
        },
        {
          description: 'yesLabel',
          value: true
        }
      ]
    },
  ]
}

export default m10Section;